import { render } from "./UserTicketConversationTecnico.vue?vue&type=template&id=868885c0&scoped=true"
import script from "./UserTicketConversationTecnico.vue?vue&type=script&lang=js"
export * from "./UserTicketConversationTecnico.vue?vue&type=script&lang=js"

import "./UserTicketConversationTecnico.vue?vue&type=style&index=0&id=868885c0&scoped=true&lang=css"
import "./styles/chatComposer.css?vue&type=style&index=1&id=868885c0&scoped=true&lang=css&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-868885c0"]])

export default __exports__